import { isNil } from 'ramda';

import Certificate from 'src/types/resources/CertificateType';
import { getFilename } from 'src/utils/string';

const CertificatePresenter = {
  filename: (certificate: Certificate): string => {
    const { file } = certificate;

    if (isNil(file)) {
      return '';
    }

    return certificate.originalFileName || getFilename(file);
  },
};

export default CertificatePresenter;
